"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enchant = enchant;
const Enchanted_1 = require("./Enchanted");
function enchant(range, comparator) {
    if (Enchanted_1.Enchanted.is(range)) {
        return range;
    }
    return Object.freeze(Object.assign(new Enchanted_1.Enchanted.Shape(comparator), range));
}
